import React from 'react';

const ArtisanProduct = ({ product }) => {
  return (
    <div className="artisan-product-card">
      <div className="artisan-img-container">
        {product.designs[0] && product.designs[0].image_data ? (
          <img 
            src={'data:image/jpeg;base64,' + product.designs[0].image_data} 
            alt={product.name || 'Product'} 
          />
        ) : (
          <p>No image available</p>
        )}
      </div>
      <div className="artisan-card-content">
        <h3>{product.name || 'No Title'}</h3>
        <p>{product.description || 'No Description'}</p>
        <p className="price">Price: ${product.price ? product.price.toFixed(2) : 'No Price'}</p>
        
        {product.designs.length > 0 && (
          <div className="colors">
            {product.designs[0].colors && product.designs[0].colors.length > 0 ? (
              product.designs[0].colors.map((color, index) => (
                <span
                  key={index}
                  className="color-swatch"
                  style={{ backgroundColor: color.color_hex_code }}
                ></span>
              ))
            ) : (
              <p>No colors available</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ArtisanProduct;
